export const bannerPicture = ['earn', 'lee',  'easy', 'share'] as const;

export type BannerPictureType = typeof bannerPicture[number];
